import { ReturnsIntakeSearchBar, ReturnsIntakeDescription } from '../../components';
import { LoaderBackdrop, NavigateLinks, Table } from '@/components';
import { ReturnsIntakeFilters } from '../../models';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useSortableData } from '@/hooks';
import {
  childrenReturnsIntakePendingShippingsBreadcrumbs,
  getPendingShippingsColumns,
} from '../../config';
import {
  usePendingShippings,
  useReturnsIntakeFilter,
  useReturnsIntakePagination,
} from '../../hooks';

export const PendingShippingsWithReturnsIntake = () => {
  const navigate = useNavigate();

  const { filter, setFilter, initialFilter } = useReturnsIntakeFilter(true, 'BUSINESS-RETURNS-INTAKE-PENDING-FILTERS');
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    useReturnsIntakePagination();

  const { shippings, totalItems, totalPages, isLoading, formatDate } =
    usePendingShippings({
      filters: filter || {},
      page: currentPage,
      pageSize,
    });

  const { sortedData, handleSort, selectedSort } = useSortableData({
    data: shippings || [],
    currentPage,
  });

  const breadcrumbs = useMemo(
    () => childrenReturnsIntakePendingShippingsBreadcrumbs(navigate),
    [navigate]
  );

  const columns = useMemo(
    () =>
      getPendingShippingsColumns({
        formatDate,
      }),
    [formatDate]
  );

  const handleSearch = (filters: ReturnsIntakeFilters) => {
    setFilter(filters);
    handlePageChange(1);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks
        actualPage='Pedidos no rendidos'
        breadcrumbs={breadcrumbs}
      />

      {isLoading && <LoaderBackdrop />}

      <ReturnsIntakeDescription 
        title="Pedidos No Rendidos"
        description="Listado de pedidos que aún no han sido entregados y se encuentran pendientes de devolución en el depósito por parte del conductor."
        color="#f59e0b"
        icon="late"
      />

      <ReturnsIntakeSearchBar
        search={handleSearch}
        initialFilter={initialFilter}
        filter={filter}
        hideStatus={true}
        dateLabel='Pendiente'
        showShippingNumber={true}
      />

      <div className='bg-white rounded-sm shadow-xl p-5 flex flex-col gap-5'>
        {shippings?.length > 0 || isLoading ? (
          <Table
            columns={columns}
            data={sortedData}
            handleSort={handleSort}
            selectedSort={selectedSort}
            isLoading={isLoading}
            getRowKey={(row) => row.shippingNumber}
            pagination={{
              totalItems,
              totalPages,
              currentPage,
              rowsPerPage: pageSize,
              onPageChange: handlePageChange,
              onRowsPerPageChange: handlePageSizeChange,
            }}
          />
        ) : (
          <span className='text-gray-500 text-sm italic text-center py-10'>
            No se han encontrado pedidos pendientes de rendición con los
            criterios actuales.
          </span>
        )}
      </div>
    </section>
  );
};
